export default {"src":"/_next/static/media/check-thin.2e7ed75a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};